import { ReactNode } from 'react';
import UnauthorisedAccess from '../component/UnauthorisedAccess';
import useHasPermission from '../hooks/useHasPermission';
import { AuthService } from '../service';
import { UserStore } from '../store';
import { ProtectedRouteInterface } from './types';

const ProtectedRoute: ProtectedRouteInterface = ({
  moduleId,
  children = null,
}) => {
  const isLoggedIn = UserStore((state) => state.isLoggedIn);
  const { hasModulePermission, rolesLoading } = useHasPermission();

  if (!isLoggedIn) {
    AuthService.logout();
    return null;
  }

  if (rolesLoading) {
    return null;
  }

  if (!hasModulePermission({ moduleId })) {
    return <UnauthorisedAccess />;
  }

  return children as ReactNode;
};

export default ProtectedRoute;
